'use client';

import { useFormContext } from '@/lib/form';
import { useStore } from '@tanstack/react-form';
import { Button } from '@sapling/ui/components/ui/button';

export function SubmitButton({
  label = 'Skicka',
  loadingLabel = 'Skickar...',
  disabled,
}: {
  label?: string;
  loadingLabel?: string;
  disabled?: boolean;
}) {
  const form = useFormContext();
  const isSubmitting = useStore(form.store, (state) => state.isSubmitting);

  return (
    <Button
      type="submit"
      className="w-full"
      disabled={isSubmitting || disabled}
    >
      {isSubmitting ? loadingLabel : label}
    </Button>
  );
}
